import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import CustomModalView from '../../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom';


const ClientSummaryView = (props) => {
if (localStorage.getItem("token") != null) {
        return (
           <>
            <div className="registration-form_main">
                <div className="registration-form_wrapper" style={{padding: '78px 73px'}}>
            <div className="dashboard-body-area" style={{width: '100%'}}>
                <section className="dashboard-page-title" >
                      <h2 >The following details have been temporarily saved to the system, but Your application is not been submmited yet. Please take a moment to review the details below then follow the instructions at the bottom of the page.</h2>
                </section>
                <section className="dashboard-page-title"  >
                      <h2 ><strong>Step 1: Company Details Summary </strong></h2>
                </section>
                <div style={{marginTop:'30px'}}>
                    <Table responsive>

                        <tbody >
                            <tr>
                                <td style={{minWidth: '15em'}}>Company Number</td>
                                <td><span className="title-crop">{props.company_detail.company_number}</span></td>

                            </tr>
                            <tr>
                                <td style={{minWidth: '15em'}}>Legal Entity</td>
                                <td><span className="title-crop">{props.company_detail.entity}</span></td>

                            </tr>
                            <tr>
                                <td style={{minWidth: '15em'}}>Registered office</td>
                                <td><span className="title-crop">{props.company_detail.office_address}</span></td>

                            </tr>


                            <tr>
                                <td style={{minWidth: '15em'}}>Trading Address</td>
                                <td><span className="title-crop">{props.company_detail.trading_address}</span></td>
                            </tr>
                             <tr>
                                <td style={{minWidth: '15em'}}>Communication Address</td>
                                <td><span className="title-crop">{props.company_detail.communication_address}</span></td>
                            </tr>
                             <tr>
                                <td style={{minWidth: '15em'}}>Phone Number</td>
                                <td><span className="title-crop">{props.company_detail.phone_number}</span></td>
                            </tr>
                             <tr>
                                <td style={{minWidth: '15em'}}>Fax</td>
                                <td><span className="title-crop">{props.company_detail.Fax_number}</span></td>
                            </tr>
                            <tr>
                                <td style={{minWidth: '15em'}}>Email</td>
                                <td><span className="title-crop">{props.company_detail.email}</span></td>
                            </tr>

                        </tbody>
                    </Table>
                </div>
                <section className="dashboard-page-title" style={{marginTop:'10px'}} >
                      <h2 >If any of the details are incorrect please hit the edit button </h2>
                      <div  style={{padding: '11px 0',width: '350px',margin:'0px 0px'}}>
                      <form>
                      <div className="form-btn_group" style={{textAlign:'start'}}>
                      <a href="/client/form1/#edit" ><button type="button" style={{width: '285px'}} className="btn btn-border">Edit <i className="fa fa-pencil-square-o"></i></button></a>
                      </div>
                       </form>
                        </div>
                </section>
                <section className="dashboard-page-title" style={{marginTop:'10px'}} >
                      <h2 >If These are correct please hit the submit button</h2>
                      <div className="login-form" style={{padding: '11px 0',width: '286px',margin:'0px 0px'}}>
                      <form>
                      <div className="field-box">
                      <a href="/client/complete" ><button type="button">Submit<i className="fa fa-sign-in"></i></button></a>
                      </div>
                       </form>
                        </div>
                </section>

            </div>
             </div>
              </div>
              <CustomModalView
                modal_show={props.modal_show}
                authResponse = {props.authResponse}
                showCustomModal= {props.showCustomModal}
                hideCustomModal={props.hideCustomModal}
                />

        </>
        )

}else{
            return(
                <Navigate to="/login" />
             )
}
}

export default ClientSummaryView;